export default __webpack_public_path__ + "static/media/cardimgfree.5771cbbb.png";